export default (props: any) => () => {
  let newForm1 = [...props.form.form].map((item: any) => ({...item, extended: false}));
  let newForm2 = [...props.form.form2].map((item: any) => ({...item, extended: false}));
  props.setForm()({target: {type: "custom", name: "form", value: newForm1}});
  props.setForm()({target: {type: "custom", name: "form2", value: newForm2}});
}